import { getToken } from "services";
import { useSelector } from "react-redux";
import { ToastContainer } from "react-toastify";
import "render-smooth-image-react/build/style.css";
import "react-toastify/dist/ReactToastify.css";
import "./App.scss";
import General from "modules/GeneralComponent/General";

function App() {
  const { authorization } = useSelector((state) => state.auth);
  getToken(authorization?.token);

  console.log(
    "%cAPP VERSION: 1.1.0",
    "color: white; background: #007acc; font-size: 14px; font-weight: bold; padding: 4px 8px; border-radius: 4px;"
  );

  return (
    <>
      <General />
      <ToastContainer />
    </>
  );
}

export default App;
